import React from "react";
import styled from "styled-components";
import BaseComponent from "../BaseComponent";
import { Image } from "semantic-ui-react";
import CheckActive from "../../assets/check-active.png";
import PillButton from "./PillButton";

const Wrapper = styled.div`
  display: flex;
  height: 60px;
  justify-content: space-between;
  align-items: center;
  padding-left: 15px;
  padding-right: 15px;
  flex-direction: row;
  margin-bottom: 6px;
  margin-top: 0px;
  margin-left: 21px;
  margin-right: 21px;
  background-color: white;
`;

const LeftPanel = styled.div`
  display: flex;
  flex-direction: column;
`;

const RightPanel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const PublisherName = styled.div`
  color: black;
  font-weight: bold;
  display: inline;
`;
const SafeFunId = styled.div`
  color: black;
  display: inline;
`;

class PeopleSearchResult extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      showSuccess: false,
    };

    this.requestSubscription = this.requestSubscription.bind(this);
  }

  async requestSubscription(sfConsumerId) {
    const response = await this.safeFunApi.requestSubscription(sfConsumerId);

    if (!response.data.success) {
      this.errorManager.addError("Failed to request to follow this user");
      this.forceUpdate();
      return;
    }
    this.setState({ showSuccess: true });
  }

  render() {
    return (
      <Wrapper>
        <LeftPanel>
          <PublisherName>
            {this.props.item.firstName + " " + this.props.item.lastName}
          </PublisherName>
          <SafeFunId>{this.props.item.safeFunId}</SafeFunId>
        </LeftPanel>
        <RightPanel>
          {this.state.showSuccess ? (
            <Image src={CheckActive} height={32} width={32} />
          ) : (
            <PillButton
              onClick={() => {
                this.requestSubscription(this.props.item.sF_ConsumerId);
              }}
              style={{
                width: 80,
                backgroundColor: "white",
                borderColor: "#1cbff2",
                borderWidth: 2,
                borderStyle: "solid",
              }}
            >
              {"Add"}
            </PillButton>
          )}
        </RightPanel>
      </Wrapper>
    );
  }
}

export default PeopleSearchResult;
